/* istanbul ignore file */
export * from './Banner';
